import { defineComponent as _defineComponent } from 'vue'
import { computed } from "vue"
import { useTranslation } from "@/i18n/useTranslation"
import { ApplicationStates } from "@/modules/Missions/components/Details/ManageTeamRoles/StaffingPositionDetails/constant"


export default /*#__PURE__*/_defineComponent({
  __name: 'ApplyButton',
  props: {
    applicationState: null,
    isApplication: { type: Boolean }
  },
  emits: ["click"],
  setup(__props: any, { emit }: { emit: ({
  (e: "click"): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  applicationState?: string
  isApplication?: boolean
}





const { t } = useTranslation("Consultant/Opportunities")

const hasApplication = computed(() => {
  return props.isApplication
})

const applicationState = computed(() => {
  return props.applicationState as keyof typeof ApplicationStates
})

const getApplicationButtonLabel = () => {
  if (!applicationState.value) return
  const btnLabelMap = {
    [ApplicationStates.approved]: t("appliedButton.approved"),
    [ApplicationStates.rejected]: t("appliedButton.rejected"),
    [ApplicationStates.pending]: t("appliedButton.pending"),
    [ApplicationStates.shortlisted]: t("appliedButton.shortlisted"),
    [ApplicationStates.declined]: t("appliedButton.declined"),
  }
  return btnLabelMap[applicationState.value] || t("appliedButton.pending")
}

return { __sfc: true,props, emit, t, hasApplication, applicationState, getApplicationButtonLabel }
}

})